// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1312E","buttons":"RemoveExpirationActionButtons_buttons__27g4q"};